import {atom} from 'recoil';

const authAtom = atom({
  key: '@auth_atom',
  default: <AuthDataT>null,
});

export default authAtom;
